import { useMemo } from "react";
import imagesPath from "../data/imagesPath";

type PropType = {
  company?: string;
};

export default function TeslaGallery({ company}: PropType) {
  const data = useMemo(() => {
    return imagesPath.find((e) => e.company === company);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imagesPath, company]);

  return (
    <div
      className=" bg-white rounded-xl "
      style={{
        boxShadow: "0px 23px 44px 0px rgba(176, 183, 195, 1)",
      }}
    >
      <div className="max-w-7xl mx-auto p-3">
        <div className="bg-white">
          {/* Main Image */}
          <div className="flex gap-1 md:gap-3">
            <div className="w-full flex-[2]">
              <img
                src={data?.img1}
                alt="Tesla RoboTaxi Main"
                className="w-full h-[220px]  rounded-lg"
              />
            </div>

            {/* Thumbnail Grid */}
            <div className="flex flex-col justify-between w-full flex-1">
              <img
                src={data?.img2}
                alt="Tesla Side View"
                className="w-full h-[105px] object-cover rounded-lg"
              />
              <img
                src={data?.img3}
                alt="Tesla Night View"
                className="w-full h-[105px] object-cover rounded-lg"
              />
            </div>
          </div>

          {/* Description */}
          <div className="mt-8">
            <h2 className="text-2xl text-black font-medium mb-4">
              Description
            </h2>
            <p className="text-zinc-400 mb-4 font-normal text-sm">
              {data?.desc}
            </p>
            <ul className="text-zinc-400 space-y-3 font-normal text-sm ml-3">
              <li className="flex items-start gap-2">{data?.point1}</li>
              <li className="flex items-start gap-2">{data?.point2}</li>
            </ul>
            <button className="text-[#C51020] font-medium text-sm mt-4">
              Read More
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

